import { connect } from 'react-redux'
import { increment, decrement } from '../actions/counter'
import { getCounter } from '../selectors/counterSelectors'
import { State } from '../reducers'
import { Dispatch } from 'redux'
import { ActionType } from '../actions'

const mapStateToProps = (state: State) => ({
  counter: getCounter(state)
})

const mapDispatchToProps = (dispatch: Dispatch<ActionType>) => ({
  increment: () => dispatch(increment()),
  decrement: () => dispatch(decrement())
})

const IndexContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)

export type IndexContainerProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>

export default IndexContainer
